import styled, { css } from 'styled-components';
import TagInfo from '../../../../components/TagInfo';

interface IContainer {
  showSearchWrapper: boolean;
}

export const PaymentMethodContainer = styled.div<IContainer>`
  height: 100%;
  ${props =>
    !props.showSearchWrapper &&
    css`
      padding: 0 32px;
      padding-top: 32px;
    `}
  overflow-y: auto;
`;

export const CardWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const TitleSection = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #898b8e;

  margin-bottom: 24px;
`;

export const Info = styled(TagInfo)``;
